// extracted by mini-css-extract-plugin
export default {"commentBox":"_1CnuqPVr","textLabel":"_261rmpag","numberLabels":"_29KgpxJJ"};